<template>
  <lazy-div :load="fetchData">
    <v-card>
      <v-card-title>
        <div class="headline">Manage GL Interface</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row-wrap>
            <v-flex xs12>
              <v-subheader class="queryLabel">{{ labels.glapplnInt }}</v-subheader>
              <div class="queryValue">{{ glIntForm.glapplnInt | glapplnIntDesc }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 v-if="GLMappingKey.sepAcctBrn">
              <v-text-field
                :label="labels.branch"
                v-model="glIntForm.branch"
                :error-messages="errors.collect('branch')"
                data-vv-name="branch"
                :data-vv-as="labels.branch"
                v-validate="'required|max:4'"
                :hint="glIntForm.brnDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist('branch')"
                :disabled="!newGlInt"
                @change="doCheck('branch')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctCtyRisk">
              <v-text-field
                :label="labels.ctyRisk"
                v-model="glIntForm.ctyRisk"
                :error-messages="errors.collect('ctyRisk')"
                data-vv-name="ctyRisk"
                :data-vv-as="labels.ctyRisk"
                v-validate="'required|max:2'"
                :hint="glIntForm.ctyRiskDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist('ctyRisk')"
                :disabled="!newGlInt"
                @change="doCheck('ctyRisk')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctDri">
              <v-autocomplete
                :label="labels.dri"
                :items="driList"
                item-text="label"
                item-value="value"
                v-model="glIntForm.dri"
                :error-messages="errors.collect('dri')"
                data-vv-name="dri"
                :data-vv-as="labels.dri"
                v-validate="'required'"
                :disabled="!newGlInt"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctPolType">
              <v-text-field
                :label="labels.polType"
                v-model="glIntForm.polType"
                :error-messages="errors.collect('polType')"
                data-vv-name="polType"
                :data-vv-as="labels.polType"
                v-validate="'required|max:4'"
                :hint="glIntForm.polTypeDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist('polType')"
                :disabled="!newGlInt"
                @change="doCheck('polType')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctBusCls">
              <v-text-field
                :label="labels.busCls"
                v-model="glIntForm.busCls"
                :error-messages="errors.collect('busCls')"
                data-vv-name="busCls"
                :data-vv-as="labels.busCls"
                v-validate="'required|max:4'"
                :hint="glIntForm.busClsDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist('busCls')"
                :disabled="!newGlInt"
                @change="doCheck('busCls')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctDept">
              <v-text-field
                :label="labels.dept"
                v-model="glIntForm.dept"
                :error-messages="errors.collect('dept')"
                data-vv-name="dept"
                :data-vv-as="labels.dept"
                v-validate="'required|max:1'"
                :hint="glIntForm.deptDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist('dept')"
                :disabled="!newGlInt"
                @change="doCheck('dept')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctCtyCed">
              <v-text-field
                :label="labels.ctyCed"
                v-model="glIntForm.ctyCed"
                :error-messages="errors.collect('ctyCed')"
                data-vv-name="ctyCed"
                :data-vv-as="labels.ctyCed"
                v-validate="'max:2'"
                :hint="glIntForm.ctyCedDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist('ctyCed')"
                :disabled="!newGlInt"
                @change="doCheck('ctyCed')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctCtyRi">
              <v-text-field
                :label="labels.ctyRi"
                v-model="glIntForm.ctyRi"
                :error-messages="errors.collect('ctyRi')"
                data-vv-name="ctyRi"
                :data-vv-as="labels.ctyRi"
                v-validate="'max:2'"
                :hint="glIntForm.ctyRiDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist('ctyRi')"
                :disabled="!newGlInt"
                @change="doCheck('ctyRi')"
              ></v-text-field>
            </v-flex>

            <v-flex xs6 v-if="GLMappingKey.sepAcctStmtLvl">
              <v-autocomplete
                :label="labels.stmtLvl"
                :items="stmtLvlList"
                item-text="label"
                item-value="value"
                v-model="glIntForm.stmtLvl"
                :error-messages="errors.collect('stmtLvl')"
                data-vv-name="stmtLvl"
                :data-vv-as="labels.stmtLvl"
                :disabled="!newGlInt"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctStmtLnGL">
              <v-text-field
                :label="labels.stmtLnGL"
                v-model="glIntForm.stmtLnGL"
                :error-messages="errors.collect('stmtLnGL')"
                data-vv-name="stmtLnGL"
                :data-vv-as="labels.stmtLnGL"
                v-validate="'max:4'"
                :hint="glIntForm.stmtLnGLDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist2('stmtLnGL')"
                :disabled="!newGlInt"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctBAGL">
              <v-text-field
                :label="labels.busAnGL"
                v-model="glIntForm.busAnGL"
                :error-messages="errors.collect('busAnGL')"
                data-vv-name="busAnGL"
                :data-vv-as="labels.busAnGL"
                v-validate="'max:4'"
                :hint="glIntForm.busAnGLDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist2('busAnGL')"
                :disabled="!newGlInt"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctCedAreaGL">
              <v-text-field
                :label="labels.cedAreaGL"
                v-model="glIntForm.cedAreaGL"
                :error-messages="errors.collect('cedAreaGL')"
                data-vv-name="cedAreaGL"
                :data-vv-as="labels.cedAreaGL"
                v-validate="'max:4'"
                :hint="glIntForm.cedAreaGLDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist2('cedAreaGL')"
                :disabled="!newGlInt"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctRiskAreaGL">
              <v-text-field
                :label="labels.riskAreaGL"
                v-model="glIntForm.riskAreaGL"
                :error-messages="errors.collect('riskAreaGL')"
                data-vv-name="riskAreaGL"
                :data-vv-as="labels.riskAreaGL"
                v-validate="'max:4'"
                :hint="glIntForm.riskAreaGLDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist2('riskAreaGL')"
                :disabled="!newGlInt"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="GLMappingKey.sepAcctRIAreaGL">
              <v-text-field
                :label="labels.riAreaGL"
                v-model="glIntForm.riAreaGL"
                :error-messages="errors.collect('riAreaGL')"
                data-vv-name="riAreaGL"
                :data-vv-as="labels.riAreaGL"
                v-validate="'max:4'"
                :hint="glIntForm.riAreaGLDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist2('riAreaGL')"
                :disabled="!newGlInt"
              ></v-text-field>
            </v-flex>
            <!--KIV-->
            <v-flex xs6 v-if="GLMappingKey.sepAcctCesCat">
              <v-text-field
                :label="labels.cesCat"
                v-model="glIntForm.cesCat"
                :error-messages="errors.collect('cesCat')"
                data-vv-name="cesCat"
                :data-vv-as="labels.cesCat"
                v-validate="'max:4'"
                :hint="glIntForm.cesCatDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist2('cesCat')"
                :disabled="!newGlInt"
                @change="doCheck2('cesCat')"
              ></v-text-field>
            </v-flex>
            <!--KIV-->
          </v-layout>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">To GL Account</div>
            <v-icon @click="doHelplist('glacctNo')">mdi-magnify</v-icon>
          </v-card-title>
          <v-layout row-wrap>
            <v-flex xs2>
              <v-text-field :label="labels.glacctBrn" v-model="glIntForm.glacctBrn" readonly></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field :label="labels.glacctNo" v-model="glIntForm.glacctNo" readonly></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field :label="labels.glacctFund" v-model="glIntForm.glacctFund" readonly></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field :label="labels.glacctSfx" v-model="glIntForm.glacctSfx" readonly></v-text-field>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row-wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ glIntForm.createdBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ glIntForm.createdDate | formatDate }}</div>
            </v-flex>
          </v-layout>
          <v-layout row-wrap v-if="!newGlInt">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ glIntForm.modifiedBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ glIntForm.modifiedDate | formatDate }}</div>
            </v-flex>
          </v-layout>
          <v-btn color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
            Save GL Interface
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-container>
      </v-card-text>
      <v-dialog v-model="helplist" width="900px" persistent>
        <helplist
          v-if="generalHelplist"
          :apiURI="helplistURI"
          :fieldList="helplistFields"
          :fieldKey1="helplistFieldKey1"
          :fieldKey2="helplistFieldKey2"
          :expand="helplistExpand"
          @select="doSelect($event)"
          @close="doClose"
        ></helplist>
        <gl-acct-no-helplist
          v-if="glacctNoHelplist"
          :apiURI="menu.glInt_glAcctNo"
          @selectGlAcctNo="doSelectGlAcctNo($event)"
          @close="doClose"
        ></gl-acct-no-helplist>
      </v-dialog>
    </v-card>
  </lazy-div>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { glAppInterface } from '@/const/acct/glAcct'
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import GlAcctNoHelplist from '../../../helplist/GLAcctNoHelplist'
import Helplist from '@/components/parameters/helplist/helplist'
export default {
  data() {
    return {
      labels: {
        glapplnInt: 'GL Application Interface',
        branch: 'Branch',
        ctyRisk: 'Country Risk',
        dri: 'Direct / RI Inwards',
        polType: 'Policy Type',
        busCls: 'Business Class',
        dept: 'Department',
        ctyCed: 'Country Cedant',
        ctyRi: 'Country RI',
        clmResCat: 'Claim Reserve Category',
        glacctBrn: 'Branch',
        glacctNo: 'Account No.',
        glacctFund: 'Fund',
        glacctSfx: 'Suffix',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        stmtLvl: 'Statement Level',
        stmtLnGL: 'Statement Line GL',
        busAnGL: 'Business Analysis GL',
        cedAreaGL: 'Cedant Area GL',
        riAreaGL: 'RI Area GL',
        cesCat: 'Cession Category',
        riskAreaGL: 'Risk Area GL'
      },
      glIntForm: {
        glapplnInt: this.$route.params.glapplnInt,
        branch: '',
        brnDesc: null,
        ctyRisk: '',
        ctyRiskDesc: null,
        dri: 'D',
        polType: '',
        polTypeDesc: null,
        busCls: '',
        busClsDesc: null,
        dept: '',
        deptDesc: null,
        ctyCed: '',
        ctyCedDesc: null,
        ctyRi: '',
        ctyRiDesc: null,
        clmResCat: '',
        glacctBrn: null,
        glacctNo: null,
        glacctFund: null,
        glacctSfx: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null,
        stmtLvl: '',
        stmtLnGL: '',
        stmtLnGLDesc: null,
        busAnGL: '',
        busAnGLDesc: null,
        cedAreaGL: '',
        cedAreaGLDesc: null,
        riAreaGL: '',
        riAreaGLDesc: null,
        riskAreaGL: '',
        riskAreaGLDesc: null,
        cesCat: '',
        cesCatDesc: null
      },
      submitting: false,
      glSys: null,
      ctyKey: null,
      helplist: false,
      glacctNoHelplist: false,
      helplistMenu: null,
      helplistURI: null,
      helplistFields: [],
      helplistFieldKey1: null,
      helplistFieldKey2: null,
      helplistExpand: null,
      generalHelplist: false
    }
  },
  methods: {
    async loadHelplist() {
      const apiURI = this.menu.glIntHelplist
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.helplistMenu = extractMenu(result.data._links)
          this.glSys = data.MiscAcctParam.glSys
        }
      }
    },
    async fetchData() {
      await this.loadHelplist()
      if (!this.newGlInt) {
        const apiURI = this.menu.glInterface
        if (apiURI) {
          try {
            const expand = {
              glapplnInt: this.id.glapplnInt,
              branch: this.id.branch,
              ctyRisk: this.id.ctyRisk,
              dri: this.id.dri,
              polType: this.id.polType,
              busCls: this.id.busCls,
              dept: this.id.dept,
              ctyCed: this.id.ctyCed,
              ctyRi: this.id.ctyRi,
              clmResCat: this.id.clmResCat
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.glIntForm.glapplnInt = data.GLInterface.glapplnInt
              this.glIntForm.branch = data.GLInterface.branch
              if (data.branch) {
                if (this.glSys === 2) {
                  this.glIntForm.brnDesc = data.branch.glanDesc
                } else {
                  this.glIntForm.brnDesc = data.branch.brnDesc
                }
              }
              this.glIntForm.ctyRisk = data.GLInterface.ctyRisk
              if (data.ctyRisk) {
                if (this.glSys === 2) {
                  this.glIntForm.ctyRiskDesc = data.ctyRisk.glanDesc
                } else {
                  this.glIntForm.ctyRiskDesc = data.ctyRisk.regn1Desc
                }
              }
              this.glIntForm.dri = data.GLInterface.dri
              this.glIntForm.polType = data.GLInterface.polType
              if (data.polType) {
                if (this.glSys === 2) {
                  this.glIntForm.polTypeDesc = data.polType.glanDesc
                } else {
                  this.glIntForm.polTypeDesc = data.polType.polTypeDesc
                }
              }
              this.glIntForm.busCls = data.GLInterface.busCls
              if (data.busCls) {
                if (this.glSys === 2) {
                  this.glIntForm.busClsDesc = data.busCls.glanDesc
                } else {
                  this.glIntForm.busClsDesc = data.busCls.busClsDesc
                }
              } else if (data.polTypeCls) {
                this.glIntForm.busClsDesc = data.polTypeCls.busClsDesc
              }
              this.glIntForm.dept = data.GLInterface.dept
              if (data.dept) {
                if (this.glSys === 2) {
                  this.glIntForm.deptDesc = data.dept.glanDesc
                } else {
                  this.glIntForm.deptDesc = data.dept.deptDesc
                }
              }
              this.glIntForm.ctyCed = data.GLInterface.ctyCed
              if (data.ctyCed) {
                if (this.glSys === 2) {
                  this.glIntForm.ctyCedDesc = data.ctyCed.glanDesc
                } else {
                  this.glIntForm.ctyCedDesc = data.ctyCed.regn1Desc
                }
              }
              this.glIntForm.ctyRi = data.GLInterface.ctyRi
              if (data.ctyRi) {
                if (this.glSys === 2) {
                  this.glIntForm.ctyRiDesc = data.ctyRi.glanDesc
                } else {
                  this.glIntForm.ctyRiDesc = data.ctyRi.regn1Desc
                }
              }
              this.glIntForm.clmResCat = data.GLInterface.clmResCat
              this.glIntForm.glacctBrn = data.GLInterface.glacctBrn
              this.glIntForm.glacctNo = data.GLInterface.glacctNo
              this.glIntForm.glacctFund = data.GLInterface.glacctFund
              this.glIntForm.glacctSfx = data.GLInterface.glacctSfx
              this.glIntForm.createdBy = data.createdBy
              this.glIntForm.createdDate = data.createdDate
              this.glIntForm.modifiedBy = data.modifiedBy
              this.glIntForm.modifiedDate = data.modifiedDate

              this.glIntForm.stmtLvl = data.GLInterface.stmtLvl
              this.glIntForm.stmtLnGL = data.GLInterface.stmtLnGL
              if (data.stmtLnGL) {
                this.glIntForm.stmtLnGLDesc = data.stmtLnGL.stmtLnGLDesc
              }
              this.glIntForm.busAnGL = data.GLInterface.busAnGL
              if (data.busAnGL) {
                this.glIntForm.busAnGLDesc = data.busAnGL.busAnGLDesc
              }
              this.glIntForm.cedAreaGL = data.GLInterface.cedAreaGL
              if (data.cedAreaGL) {
                this.glIntForm.cedAreaGLDesc = data.cedAreaGL.riskAreaGLDesc
              }
              this.glIntForm.riAreaGL = data.GLInterface.riAreaGL
              if (data.riAreaGL) {
                this.glIntForm.riAreaGLDesc = data.riAreaGL.riskAreaGLDesc
              }
              this.glIntForm.riskAreaGL = data.GLInterface.riskAreaGL
              if (data.riskAreaGL) {
                this.glIntForm.riskAreaGLDesc = data.riskAreaGL.riskAreaGLDesc
              }
              this.glIntForm.cesCat = data.GLInterface.cesCat
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      } else {
        this.glIntForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.glIntForm.createdDate = new Date()
      }
    },
    doHelplist(field) {
      this.resetMessages()
      this.helplist = true
      this.helplistExpand = {}
      this.helplistFieldKey1 = field
      if (this.glSys === 2) {
        this.doGLACHelplist(field)
      } else {
        this.doNormalHelplist(field)
      }
    },
    doHelplist2(field) {
      this.resetMessages()
      this.helplist = true
      this.helplistExpand = {}
      this.helplistFieldKey1 = field
      this.doNormalHelplist(field)
    },
    doGLACHelplist(field) {
      this.helplistExpand = {}
      this.helplistURI = this.helplistMenu.glacHelplist
      this.helplistFields = [
        { text: 'GLAC Code', value: 'glanCode' },
        { text: 'GLAC Type', value: 'glanType' },
        { text: 'Description', value: 'glanDesc' }
      ]
      this.helplistFieldKey2 = 'glanCode'
      switch (field) {
        case 'ctyRi': {
          this.generalHelplist = true
          this.helplistExpand.glanType = 'CF'
          break
        }
        case 'ctyRisk': {
          this.generalHelplist = true
          this.helplistExpand.glanType = 'CR'
          break
        }
        case 'ctyCed': {
          this.generalHelplist = true
          this.helplistExpand.glanType = 'CC'
          break
        }
        case 'dept': {
          this.generalHelplist = true
          this.helplistExpand.glanType = 'DT'
          break
        }
        case 'polType': {
          this.generalHelplist = true
          this.helplistExpand.glanType = 'PT'
          break
        }
        case 'busCls': {
          this.generalHelplist = true
          this.helplistExpand.glanType = 'BC'
          break
        }
        case 'branch': {
          this.generalHelplist = true
          this.helplistExpand.glanType = 'BH'
          break
        }
        case 'glacctNo': {
          this.glacctNoHelplist = true
          break
        }
        default: {
          this.helplist = false
          this.generalHelplist = false
          this.glacctNoHelplist = false
          break
        }
      }
    },
    doNormalHelplist(field) {
      switch (field) {
        case 'ctyRi':
        case 'ctyRisk':
        case 'ctyCed': {
          this.generalHelplist = true
          this.helplistURI = this.helplistMenu.ctyHelplist
          this.helplistFieldKey2 = 'cty'
          this.helplistFields = [
            { text: 'Region1', value: 'region1', hidden: true },
            { value: 'regn1Desc', hidden: true },
            { text: 'Country', value: 'cty' },
            { text: 'Description', value: 'ctyDesc' }
          ]
          break
        }
        // case 'ctyRisk': {
        //   this.generalHelplist = true
        //   this.helplistURI = this.helplistMenu.ctyHelplist
        //   this.helplistFieldKey2 = 'cty'
        //   this.helplistFields = [
        //     { text: 'Region1', value: 'region1', hidden: true },
        //     { value: 'regn1Desc', hidden: true },
        //     { text: 'Country', value: 'cty' },
        //     { text: 'Description', value: 'ctyDesc' }
        //   ]
        //   break
        // }
        // case 'ctyCed': {
        //   this.generalHelplist = true
        //   this.helplistURI = this.helplistMenu.ctyHelplist
        //   this.helplistFieldKey2 = 'cty'
        //   this.helplistFields = [
        //     { text: 'Region1', value: 'region1', hidden: true },
        //     { value: 'regn1Desc', hidden: true },
        //     { text: 'Country', value: 'cty' },
        //     { text: 'Description', value: 'ctyDesc' }
        //   ]
        //   break
        // }
        case 'dept': {
          this.generalHelplist = true
          this.helplistURI = this.helplistMenu.deptHelplist
          this.helplistFields = [
            { text: 'Department', value: 'dept' },
            { text: 'Description', value: 'deptDesc' }
          ]
          break
        }
        case 'polType': {
          this.generalHelplist = true
          this.helplistURI = this.helplistMenu.polTypeHelplist
          this.helplistFields = [
            { text: 'Policy Type', value: 'polType' },
            { text: 'Description', value: 'polTypeDesc' }
          ]
          break
        }
        case 'busCls': {
          this.generalHelplist = true
          if (this.GLMappingKey.sepAcctPolType) {
            // polTypeCls
            if (!this.glIntForm.polType) {
              this.$toast.error('Must key in a Policy Type value')
              this.doClose()
            } else {
              this.helplistURI = this.helplistMenu.polTypeClsHelplist
              this.helplistFieldKey2 = 'polTypeCls'
              this.helplistExpand.polType = this.glIntForm.polType
              this.helplistFields = [
                { text: 'Policy Type', value: 'polType' },
                { text: 'Business Class', value: 'busCls' },
                { text: 'Description', value: 'busClsDesc' }
              ]
            }
          } else {
            // busCls
            this.helplistURI = this.helplistMenu.busClsHelplist
            this.helplistFields = [
              { text: 'Business Class', value: 'busCls' },
              { text: 'Description', value: 'busClsDesc' }
            ]
          }
          break
        }
        case 'branch': {
          this.generalHelplist = true
          this.helplistFieldKey1 = 'branch'
          this.helplistURI = this.helplistMenu.branchHelplist
          this.helplistFields = [
            { text: 'Branch', value: 'branch' },
            { text: 'Description', value: 'brnDesc' }
          ]
          break
        }
        case 'glacctNo': {
          this.glacctNoHelplist = true
          break
        }
        case 'stmtLnGL': {
          this.generalHelplist = true
          this.helplistFieldKey1 = 'stmtLnGL'
          this.helplistURI = this.helplistMenu.stmtLnGLHelplist
          this.helplistFields = [
            { text: 'Statement Line GL', value: 'stmtLnGL' },
            { text: 'Description', value: 'stmtLnGLDesc' }
          ]
          break
        }
        case 'busAnGL': {
          this.generalHelplist = true
          this.helplistFieldKey1 = 'busAnGL'
          this.helplistURI = this.helplistMenu.busAnGLHelplist
          this.helplistFields = [
            { text: 'Business Analysis GL', value: 'busAnGL' },
            { text: 'Description', value: 'busAnGLDesc' }
          ]
          break
        }
        case 'cedAreaGL': {
          this.generalHelplist = true
          this.helplistFieldKey1 = 'cedAreaGL'
          this.helplistURI = this.helplistMenu.riskAreaGLHelplist
          this.helplistFields = [
            { text: 'Cedant Area GL', value: 'riskAreaGL' },
            { text: 'Description', value: 'riskAreaGLDesc' }
          ]
          break
        }
        case 'riAreaGL': {
          this.generalHelplist = true
          this.helplistFieldKey1 = 'riAreaGL'
          this.helplistURI = this.helplistMenu.riskAreaGLHelplist
          this.helplistFields = [
            { text: 'RI Area GL', value: 'riskAreaGL' },
            { text: 'Description', value: 'riskAreaGLDesc' }
          ]
          break
        }
        case 'riskAreaGL': {
          this.generalHelplist = true
          this.helplistFieldKey1 = 'riskAreaGL'
          this.helplistURI = this.helplistMenu.riskAreaGLHelplist
          this.helplistFields = [
            { text: 'Risk Area GL', value: 'riskAreaGL' },
            { text: 'Description', value: 'riskAreaGLDesc' }
          ]
          break
        }
        default: {
          this.helplist = false
          this.generalHelplist = false
          this.glacctNoHelplist = false
          break
        }
      }
    },
    doSelect(result) {
      this.resetMessages()
      if (this.glSys === 2) {
        this.doGLACSelect(result)
      } else {
        this.doNormalSelect(result)
      }
      this.doNormalSelect2(result)
    },
    doGLACSelect(result) {
      if (result && result.fieldKey1 && result.data) {
        switch (result.fieldKey1) {
          case 'polType': {
            this.glIntForm.polType = result.data.glanCode
            this.glIntForm.polTypeDesc = result.data.glanDesc
            break
          }
          case 'dept': {
            this.glIntForm.dept = result.data.glanCode
            this.glIntForm.deptDesc = result.data.glanDesc
            break
          }
          case 'busCls': {
            this.glIntForm.busCls = result.data.glanCode
            this.glIntForm.busClsDesc = result.data.glanDesc
            break
          }
          case 'branch': {
            this.glIntForm.branch = result.data.glanCode
            this.glIntForm.brnDesc = result.data.glanDesc
            break
          }
          case 'ctyRisk': {
            this.glIntForm.ctyRisk = result.data.glanCode
            this.glIntForm.ctyRiskDesc = result.data.glanDesc
            break
          }
          case 'ctyRi': {
            this.glIntForm.ctyRi = result.data.glanCode
            this.glIntForm.ctyRiDesc = result.data.glanDesc
            break
          }
          case 'ctyCed': {
            this.glIntForm.ctyCed = result.data.glanCode
            this.glIntForm.ctyCedDesc = result.data.glanDesc
            break
          }
        }
      }
    },
    doNormalSelect(result) {
      if (result && result.fieldKey1 && result.data) {
        switch (result.fieldKey1) {
          case 'polType': {
            this.glIntForm.polType = result.data.polType
            this.glIntForm.polTypeDesc = result.data.polTypeDesc
            break
          }
          case 'dept': {
            this.glIntForm.dept = result.data.dept
            this.glIntForm.deptDesc = result.data.deptDesc
            break
          }
          case 'busCls': {
            this.glIntForm.busCls = result.data.busCls
            this.glIntForm.busClsDesc = result.data.busClsDesc
            break
          }
          case 'branch': {
            this.glIntForm.branch = result.data.branch
            this.glIntForm.brnDesc = result.data.brnDesc
            break
          }
          case 'ctyRisk': {
            this.glIntForm.ctyRisk = result.data.region1
            this.glIntForm.ctyRiskDesc = result.data.regn1Desc
            break
          }
          case 'ctyRi': {
            this.glIntForm.ctyRi = result.data.region1
            this.glIntForm.ctyRiDesc = result.data.regn1Desc
            break
          }
          case 'ctyCed': {
            this.glIntForm.ctyCed = result.data.region1
            this.glIntForm.ctyCedDesc = result.data.regn1Desc
            break
          }
        }
      }
    },
    doNormalSelect2(result) {
      if (result && result.fieldKey1 && result.data) {
        switch (result.fieldKey1) {
          case 'stmtLnGL': {
            this.glIntForm.stmtLnGL = result.data.stmtLnGL
            this.glIntForm.stmtLnGLDesc = result.data.stmtLnGLDesc
            break
          }
          case 'busAnGL': {
            this.glIntForm.busAnGL = result.data.busAnGL
            this.glIntForm.busAnGLDesc = result.data.busAnGLDesc
            break
          }
          case 'cedAreaGL': {
            this.glIntForm.cedAreaGL = result.data.riskAreaGL
            this.glIntForm.cedAreaGLDesc = result.data.riskAreaGLDesc
            break
          }
          case 'riAreaGL': {
            this.glIntForm.riAreaGL = result.data.riskAreaGL
            this.glIntForm.riAreaGLDesc = result.data.riskAreaGLDesc
            break
          }
          case 'riskAreaGL': {
            this.glIntForm.riskAreaGL = result.data.riskAreaGL
            this.glIntForm.riskAreaGLDesc = result.data.riskAreaGLDesc
            break
          }
        }
      }
    },
    doValidate(field) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(this.fields[field].valid)
        }, 100)
      })
    },
    async doCheck(field) {
      this.doValidate(field).then((result) => {
        if (result) {
          if (this.glSys === 2) {
            this.doGLACCheck(field)
          } else {
            this.doNormalCheck(field)
          }
        }
      })
    },
    async doGLACCheck(field) {
      let expand = {}
      const apiURI = this.helplistMenu.glac
      let desc = null
      switch (field) {
        case 'polType': {
          desc = 'polTypeDesc'
          expand.glanCode = this.glIntForm.polType
          expand.glanType = 'PT'
          break
        }
        case 'dept': {
          desc = 'deptDesc'
          expand.glanCode = this.glIntForm.dept
          expand.glanType = 'DT'
          break
        }
        case 'busCls': {
          desc = 'busClsDesc'
          expand.glanCode = this.glIntForm.busCls
          expand.glanType = 'BC'
          break
        }
        case 'branch': {
          desc = 'brnDesc'
          expand.glanCode = this.glIntForm.branch
          expand.glanType = 'BH'
          break
        }
        case 'ctyRisk': {
          desc = 'ctyRiskDesc'
          expand.glanCode = this.glIntForm.ctyRisk
          expand.glanType = 'CR'
          break
        }
        case 'ctyRi': {
          desc = 'ctyRiDesc'
          expand.glanCode = this.glIntForm.ctyRi
          expand.glanType = 'CF'
          break
        }
        case 'ctyCed': {
          desc = 'ctyCedDesc'
          expand.glanCode = this.glIntForm.ctyCed
          expand.glanType = 'CC'
          break
        }
      }
      this.glIntForm[desc] = null
      if (apiURI) {
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.glIntForm[desc] = data.glanCode.glanDesc
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
            this.glIntForm[field] = null
          }
        }
      }
    },
    async doNormalCheck(field) {
      let key = field
      let desc = null
      let desc2 = null
      let apiURI = null
      let expand = {}
      switch (field) {
        case 'polType': {
          desc = 'polTypeDesc'
          apiURI = this.helplistMenu.polType
          expand.polType = this.glIntForm.polType
          break
        }
        case 'dept': {
          desc = 'deptDesc'
          apiURI = this.helplistMenu.dept
          expand.dept = this.glIntForm.dept
          break
        }
        case 'busCls': {
          desc = 'busClsDesc'
          apiURI = this.helplistMenu.busCls
          expand.busCls = this.glIntForm.busCls
          if (this.GLMappingKey.sepAcctPolType) {
            key = 'polTypeCls'
            apiURI = this.helplistMenu.polTypeCls
            expand.polType = this.glIntForm.polType
          }
          break
        }
        case 'branch': {
          desc = 'brnDesc'
          apiURI = this.helplistMenu.branch
          expand.branch = this.glIntForm.branch
          break
        }
        case 'ctyRisk': {
          desc = 'ctyRiskDesc'
          desc2 = 'regn1Desc'
          key = 'region1'
          apiURI = this.helplistMenu.region1
          expand.region1 = this.glIntForm.ctyRisk
          break
        }
        case 'ctyRi': {
          desc = 'ctyRiDesc'
          desc2 = 'regn1Desc'
          key = 'region1'
          apiURI = this.helplistMenu.region1
          expand.region1 = this.glIntForm.ctyRi
          break
        }
        case 'ctyCed': {
          desc = 'ctyCedDesc'
          desc2 = 'regn1Desc'
          key = 'region1'
          apiURI = this.helplistMenu.region1
          expand.region1 = this.glIntForm.ctyCed
          break
        }
      }
      this.glIntForm[desc] = null
      if (!desc2) {
        desc2 = desc
      }
      if (apiURI) {
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.glIntForm[desc] = data[key][desc2]
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
            this.glIntForm[field] = null
          }
        }
      }
    },
    doSelectGlAcctNo(data) {
      if (data.data) {
        this.glIntForm.glacctBrn = data.data.branch
        this.glIntForm.glacctNo = data.data.glacctNo
        this.glIntForm.glacctFund = data.data.fund
        this.glIntForm.glacctSfx = data.data.acctNoSfx
      }
      this.doClose()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.glIntForm.glacctBrn && !this.glIntForm.glacctFund && !this.glIntForm.glacctNo && !this.glIntForm.glacctSfx) {
            this.$toast.error('Must select a GL Account No record')
            return
          }
          this.submitting = true

          if (!this.GLMappingKey.sepAcctDri) {
            this.glIntForm.dri = ''
          }

          if (this.newGlInt) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createGlInt
      if (apiURI) {
        try {
          const result = await this.$http.post(apiURI, this.glIntForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateGlInt
      if (apiURI) {
        try {
          const result = await this.$http.put(apiURI, this.glIntForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doClose() {
      this.helplist = false
      this.helplistFieldKey2 = null
      setTimeout(() => {
        this.glacctNoHelplist = false
        this.generalHelplist = false
      }, 200)
    }
  },
  computed: {
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    GLMappingKey() {
      return this.$store.state.glAcctParam.glMapping.glMappingKey
    },
    driList() {
      return [
        { label: 'Direct', value: 'D' },
        { label: 'RI Inwards', value: 'R' }
      ]
    },
    stmtLvlList() {
      return [{ label: '2', value: '2' }]
    }
  },
  components: {
    GlAcctNoHelplist,
    Helplist
  },
  filters: {
    glapplnIntDesc(value) {
      return value + ' - ' + glAppInterface[value]
    },
    formatDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return null
      }
    }
  },
  mixins: [MessageMixin],
  props: {
    id: Object,
    newGlInt: Boolean
  }
}
</script>

<style>
</style>
